import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import store from "./redux/store";
import { GoogleOAuthProvider } from '@react-oauth/google';
import 'bootstrap/dist/css/bootstrap.min.css';
// import './assets/scss/style.scss';
import './assets/css/login.css';
import './assets/css/first-page.css';
import './assets/css/welcome.css';
import 'react-phone-input-2/lib/style.css';
// import 'flag-icon-css/css/flag-icon.min.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <GoogleOAuthProvider clientId="993475840624-rvil17ob7j6dnl5qfi0rpi2smkd3ft35.apps.googleusercontent.com">
      <Provider store={store}>
        <BrowserRouter
          basename="/"
          // basename="/asklms"
        >
          <App />
        </BrowserRouter>
      </Provider>
    </GoogleOAuthProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
